import { Seo } from "@/components/Seo";
import { Reveal, Tag } from "@/components/System";
import { USE_CASES } from "@/data/content";

const UseCases = () => (
    <div>
        <Seo path="/use-cases" />
        <section className="relative overflow-hidden px-4 pb-16 pt-36 sm:px-6">
            <div className="vm-grid-bg pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl">
                <div className="vm-micro mb-6">AGENTVM://USE_CASES</div>
                <h1 className="max-w-4xl text-4xl font-bold tracking-tight text-[#F5F9FF] sm:text-6xl">
                    SENSITIVE WORK.
                    <br />
                    <span className="text-[#00D9FF] vm-glow">VERIFIABLE OUTCOMES.</span>
                </h1>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8C7D9] sm:text-lg">
                    Every scenario follows the same pattern: private input, protected execution, verification, output,
                    economic action. Maturity labels reflect the documented state of each capability.
                </p>
            </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-6" data-testid="use-cases-grid">
            <div className="grid gap-5 lg:grid-cols-2">
                {USE_CASES.map((u, i) => (
                    <Reveal key={u.title} delay={(i % 2) * 0.08}>
                        <div className="vm-panel group flex h-full flex-col transition-colors duration-300 hover:border-[#00D9FF]/40" data-testid={`use-case-${i}`}>
                            <div className="flex items-center justify-between border-b border-[rgba(0,217,255,0.12)] px-5 py-3">
                                <span className="vm-micro">{u.title}</span>
                                <Tag tone={u.status === "CONCEPTUAL" ? "concept" : "dev"}>{u.status}</Tag>
                            </div>
                            <div className="flex flex-1 flex-col p-5 sm:p-6">
                                <p className="text-sm leading-relaxed text-[#B8C7D9]">{u.scenario}</p>
                                <div className="mt-6 flex flex-1 flex-wrap items-center gap-y-2">
                                    {u.flow.map((step, j) => (
                                        <div key={step} className="flex items-center">
                                            <span className={`border px-2.5 py-1.5 font-mono text-[9px] tracking-[0.16em] ${
                                                j === u.flow.length - 1
                                                    ? "border-[#00D9FF]/50 text-[#00D9FF]"
                                                    : "border-[rgba(0,217,255,0.18)] text-[#B8C7D9]/80"
                                            }`}>
                                                {step}
                                            </span>
                                            {j < u.flow.length - 1 && <span className="px-1.5 text-[#00D9FF]/50">↓</span>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.1}>
                <p className="vm-micro-dim mt-10 text-center">
                    SCENARIOS ARE DESIGN-LEVEL DESCRIPTIONS. NO CUSTOMER, ADOPTION, OR DEPLOYMENT CLAIMS ARE MADE.
                </p>
            </Reveal>
        </section>
    </div>
);

export default UseCases;
